<template>
  <div class="container">
    <div class="top_container">
      <span>维修记录</span>
    </div>
    <div class="wrapper" ref="wrapper">
      <div class="content">
        <div class="pulldown-wrapper loading_text">
          <div v-show="beforePullDown">
            <span>下拉刷新数据</span>
          </div>
          <div v-show="!beforePullDown">
            <div v-show="isPullingDown">
              <span>加载中...</span>
            </div>
            <div v-show="!isPullingDown">
              <span>刷新成功</span>
            </div>
          </div>
        </div>
        <template v-if="orderList.length > 0">
          <div v-for="order in orderList" :key="order.id" @click="goDetail(order.id, order.data_type)" class="history_item">
            <div class="top">
              <span class="code">#{{ order.code }}</span>
              <span class="status">{{ order.status_name }}</span>
            </div>
            <div class="middle">
              <div class="middle_item">
                <span class="title">故障描述</span>
                <span class="value">{{ order.content }}</span>
              </div>
              <div class="middle_item" style="padding: 10px 0">
                <span class="title">报修时间</span>
                <span class="value">{{ order.created_at }}</span>
              </div>
              <div class="middle_item">
                <span class="title">处理人</span>
                <span class="value">
                  {{ order.handler_real_name }}
                  <a style="color: #3263f2" @click.stop="() => onTel(order.handler_mobile)">{{ order.handler_mobile }}</a>
                </span>
              </div>
              <div class="middle_item" style="padding: 10px 0">
                <span class="title">故障类别</span>
                <span class="value">{{ order.big_fault_category }}{{ order.small_fault_category !== '' ? '/' + order.small_fault_category : '' }}</span>
              </div>
              <div class="middle_item">
                <span class="title">处理结果</span>
                <span class="value">{{ order.finish_content }}</span>
              </div>
            </div>
          </div>
        </template>
        <div class="loading" v-if="firstLoading"><a-icon type="loading" /></div>
        <div class="empty_container" v-if="orderList.length === 0 && !firstLoading">
          <img src="@/assets/image/empty.png" alt="">
          <div>暂无维修记录</div>
        </div>
        <div v-if="!noMore" style="padding: 10px" class="loading_text">
          <div v-if="!isPullUpLoad">
            <span>上拉加载更多</span>
          </div>
          <div v-else>
            <span>加载中...</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_container">
      <div @click="goProductDetail">
        <a-icon type="appstore" />
        <span>产品信息</span>
      </div>
      <div class="current">
        <a-icon type="customer-service" />
        <span>维修记录</span>
      </div>
      <div @click="goQuestion">
        <a-icon type="interaction" />
        <span>常见问题</span>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request';
import BScroll from '@better-scroll/core'
import PullDown from '@better-scroll/pull-down'
import Pullup from '@better-scroll/pull-up'
BScroll.use(PullDown)
BScroll.use(Pullup)
export default {
  data () {
    return {
      bscroll: null,
      beforePullDown: true,
      isPullingDown: false,
      isPullUpLoad: false,
      enterprise_id: 0,
      single_product_id: 0,
      page: 1,
      limit: 30,
      orderList: [],
      noMore: true,
      firstLoading: true,
      qrId: 0
    }
  },
  created: async function () {
    this.enterprise_id = this.$route.query.enterpriseId
    this.single_product_id = this.$route.query.singleProductId
    this.qrId = this.$route.query.qr_id
    await this.loadData()
  },
  mounted () {
    this.initBscroll()
  },
  methods: {
    onTel (mobile) {
      window.location.href = `tel: ${mobile}`
    },
    goDetail (id,data_type) {
      this.$router.push({ path: '/fh', query: { 
        id: id,
        data_type: data_type,
        is_back: true
      }})
    },
    goQuestion () {
      this.$router.replace({ path: '/q', query: { 
        enterpriseId: this.enterprise_id,
        qr_id: this.qrId,
        singleProductId: this.single_product_id
      }})
    },
    goProductDetail () {
      this.$router.replace({ path: '/s', query: { 
        qr_id: this.qrId
      }})
    },
    async loadData (type = '') {
      const that = this
      await request({
        url: 'single_product/feedback_history',
        data: { enterprise_id: this.enterprise_id, qr_id: this.qrId, pageNo: this.page, pageSize: this.limit }
      }).then(r => {
        this.firstLoading = false
        if (r.data.data.length > 0) {
          if (type === 'refresh') {
            this.orderList = r.data.data
          } else {
            this.orderList = this.orderList.concat(r.data.data);
          }
          this.page++
          this.noMore = false
          // this.$nextTick(() => {
            // this.bscroll.openPullUp()
            // this.bscroll.refresh()
          // })
        }
        this.$nextTick(() => {
          this.bscroll.closePullUp()
          this.noMore = true
        })
        setTimeout(function () {
          that.bscroll.refresh()
        }, 300)
      })
    },
    initBscroll() {
      this.bscroll = new BScroll(this.$refs.wrapper, {
        scrollY: true,
        bounceTime: 800,
        useTransition: false,
        pullDownRefresh: {
          threshold: 70,
          stop: 56
        },
        listenScroll: true,
        click: true,
        pullUpLoad: true
      })
      this.bscroll.on('pullingDown', this.pullingDownHandler)
      this.bscroll.on('pullingUp', this.pullingUpHandler)
    },
    async pullingDownHandler() {
      this.beforePullDown = false
      this.isPullingDown = true

      // 请求数据
      this.page = 1
      await this.loadData('refresh')

      this.isPullingDown = false
      this.finishPullDown()
    },
    finishPullDown() {
      this.bscroll.finishPullDown()
      setTimeout(() => {
        this.beforePullDown = true
        this.bscroll.refresh()
      }, 800 + 100)
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true
      await this.loadData()
      if (!this.noMore) {
        this.bscroll.finishPullUp()
      }
      this.bscroll.refresh()
      this.isPullUpLoad = false
    }
  }
}
</script>
<style lang="less" scoped>
.container{
  padding: 8px;
  padding-top: 58px;
  .history_item{
    border-radius: 10px;
    background-color: #fff;
    margin-bottom: 10px;
    .top{
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code{
        font-size: 20px;
        color: #009bfc;
      }
      .status{
        font-size: 16px;
        color: red;
      }
    }
    .middle{
      font-size: 16px;
      padding: 10px;
      border-top: 1px solid #f1f1f1;
      border-bottom: 1px solid #f1f1f1;
      .middle_item {
        display: flex;
        .title{
          color: #999; 
          width: 80px;
        }
        .value{
          flex: 1;
          color: #222;
        }
      }
    }
    .bottom{
      font-size: 16px;
      color: #999;
      padding: 10px;
    }
  }
  .wrapper{
    position: fixed;
    bottom: 70px;
    height: calc(100% - 128px);
    width: calc(100% - 20px);
    .pulldown-wrapper{
      position: absolute;
      width: 100%;
      padding: 22px;
      box-sizing: border-box;
      transform: translateY(-100%) translateZ(0);
    }
    .loading_text{
      text-align: center;
      color: #999;
    }
  }
}
.empty_container{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    margin-top: 30%;
    width: 80%;
  }
}
.loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(240,242,245, 1);
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}
</style>
